import { Box, Container, Grid, Typography } from "@mui/material";
import React from "react";
import arrow1 from "../../images/arrow.svg";
import arrow2 from "../../images/arrow-2.svg";

const HowItWorks = () => {
  return (
    <div className="how-it-works">
      <Container sx={{ py: 6 }}>
        <Box sx={{ textAlign: "center" }}>
          <Typography
            sx={{ fontSize: 14, textTransform: "uppercase", mb: 2 }}
            variant="subtitle1"
          >
            Whats the function
          </Typography>
          <Typography className="section-title" variant="h3">
            Let’s see how it works
          </Typography>
        </Box>
        <Box sx={{ flexGrow: 1, mt: 8 }}>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 2, sm: 8, md: 12 }}
            sx={{ textAlign: { xs: "center", md: "left" } }}
          >
            <Grid className="arrow1-container" item xs={2} sm={4} md={3}>
              <Box className="arrow1">
                <img src={arrow1} alt="" />
              </Box>
              <Box>
                <Typography
                  sx={{
                    bgcolor: "#fff",
                    color: "#22437D",
                    fontSize: 30,
                    fontWeight: 400,
                    p: 2,
                    borderRadius: 10,
                    width: 65,
                    textAlign: "center",
                    mb: 4,
                    mx: { xs: "auto", md: "inherit" },
                  }}
                  variant="h2"
                >
                  01
                </Typography>
                <Typography
                  sx={{ fontSize: 22, fontWeight: 700, mb: 2 }}
                  variant="h3"
                >
                  Set disbursement Instructions
                </Typography>
                <Typography
                  sx={{ fontSize: 15, color: "rgba(255,255,255,0.65)" }}
                  variant="body1"
                >
                  Get your blood tests delivered at home collect a sample from
                  the your blood tests.
                </Typography>
              </Box>
            </Grid>
            <Grid className="arrow2-container" item xs={2} sm={4} md={3}>
              <Box className="arrow2">
                <img src={arrow2} alt="" />
              </Box>
              <Box>
                <Typography
                  sx={{
                    bgcolor: "#fff",
                    color: "#22437D",
                    fontSize: 30,
                    fontWeight: 400,
                    p: 2,
                    borderRadius: 10,
                    width: 65,
                    textAlign: "center",
                    mb: 4,
                    mx: { xs: "auto", md: "inherit" },
                  }}
                  variant="h2"
                >
                  02
                </Typography>
                <Typography
                  sx={{ fontSize: 22, fontWeight: 700, mb: 2 }}
                  variant="h3"
                >
                  Assembly retrieves funds from your account
                </Typography>
                <Typography
                  sx={{ fontSize: 15, color: "rgba(255,255,255,0.65)" }}
                  variant="body1"
                >
                  Get your blood tests delivered at home collect a sample from
                  the your blood tests.
                </Typography>
              </Box>
            </Grid>
            <Grid className="arrow1-container" item xs={2} sm={4} md={3}>
              <Box className="arrow1">
                <img src={arrow1} alt="" />
              </Box>
              <Box>
                <Typography
                  sx={{
                    bgcolor: "#fff",
                    color: "#22437D",
                    fontSize: 30,
                    fontWeight: 400,
                    p: 2,
                    borderRadius: 10,
                    width: 65,
                    textAlign: "center",
                    mb: 4,
                    mx: { xs: "auto", md: "inherit" },
                  }}
                  variant="h2"
                >
                  03
                </Typography>
                <Typography
                  sx={{ fontSize: 22, fontWeight: 700, mb: 2 }}
                  variant="h3"
                >
                  Assembly initiates disbursement
                </Typography>
                <Typography
                  sx={{ fontSize: 15, color: "rgba(255,255,255,0.65)" }}
                  variant="body1"
                >
                  Get your blood tests delivered at home collect a sample from
                  the your blood tests.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={2} sm={4} md={3}>
              <Box>
                <Typography
                  sx={{
                    bgcolor: "#fff",
                    color: "#22437D",
                    fontSize: 30,
                    fontWeight: 400,
                    p: 2,
                    borderRadius: 10,
                    width: 65,
                    textAlign: "center",
                    mb: 4,
                    mx: { xs: "auto", md: "inherit" },
                  }}
                  variant="h2"
                >
                  04
                </Typography>
                <Typography
                  sx={{ fontSize: 22, fontWeight: 700, mb: 2 }}
                  variant="h3"
                >
                  Customer receives funds payment
                </Typography>
                <Typography
                  sx={{ fontSize: 15, color: "rgba(255,255,255,0.65)" }}
                  variant="body1"
                >
                  Get your blood tests delivered at home collect a sample from
                  the your blood tests.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  );
};

export default HowItWorks;
